module.exports = __webpack_public_path__ + "img/playbar_pause.dd818c2e.svg";